import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { fmtDateTime } from "../lib/api";
import { Field, StatusPill } from "../components/Primitives";
import FileUploader from "../components/FileUploader";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

const emptyForm = {
  customer_name: "", phone: "", registration_no: "", make: "", model: "", year: new Date().getFullYear(),
  kms_in: 0, fuel_level: "Full", reported_issues: "", image_ids: [], damage_notes: "",
};

export default function Intake() {
  const [intakes, setIntakes] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [customers, setCustomers] = useState([]);
  const nav = useNavigate();

  const load = async () => {
    const { data } = await api.get("/intakes");
    setIntakes(data);
  };
  useEffect(() => {
    load();
    api.get("/customers").then(({ data }) => setCustomers(data));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...form, kms_in: +form.kms_in, year: +form.year };
      const { data } = await api.post("/intakes", payload);
      toast.success("Intake created");
      setOpen(false);
      setForm(emptyForm);
      load();
      nav(`/service/intake/${data.id}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div>
          <div className="kk-overline">04 · 01</div>
          <h2 className="font-display text-2xl uppercase">Vehicle Intake</h2>
        </div>
        <button className="kk-btn-primary" onClick={() => setOpen(true)} data-testid="new-intake">
          <Plus size={14} /> New Intake
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="kk-table">
          <thead>
            <tr>
              <th>Code</th>
              <th>Customer</th>
              <th>Vehicle</th>
              <th>KMs In</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {intakes.map((i) => (
              <tr key={i.id} onClick={() => nav(`/service/intake/${i.id}`)} className="cursor-pointer" data-testid={`intake-row-${i.id}`}>
                <td className="font-mono">{i.code}</td>
                <td>{i.customer_name}<div className="text-xs text-[var(--kk-muted)]">{i.phone}</div></td>
                <td>{i.make} {i.model}<div className="text-xs font-mono text-[var(--kk-muted)]">{i.registration_no}</div></td>
                <td className="font-mono">{i.kms_in?.toLocaleString?.()}</td>
                <td><StatusPill status={i.status} /></td>
                <td className="font-mono text-xs">{fmtDateTime(i.created_at)}</td>
              </tr>
            ))}
            {intakes.length === 0 && (
              <tr><td colSpan={6} className="text-center text-[var(--kk-muted)] py-8">No intakes yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="fixed inset-0 bg-black/30 z-50 flex justify-end" onClick={() => setOpen(false)}>
          <form onSubmit={save} onClick={(e) => e.stopPropagation()}
                className="w-full max-w-2xl bg-[var(--kk-surface)] p-8 overflow-y-auto">
            <div className="flex items-center justify-between">
              <h2 className="font-display text-2xl uppercase">New Intake</h2>
              <button type="button" onClick={() => setOpen(false)}><X /></button>
            </div>
            <div className="grid grid-cols-2 gap-5 mt-5">
              <Field label="Customer"><input className="kk-input" required value={form.customer_name} onChange={upd("customer_name")} data-testid="intake-customer" /></Field>
              <Field label="Phone"><input className="kk-input" required value={form.phone} onChange={upd("phone")} /></Field>
              <Field label="Reg #"><input className="kk-input" required value={form.registration_no} onChange={upd("registration_no")} /></Field>
              <Field label="Make"><input className="kk-input" required value={form.make} onChange={upd("make")} /></Field>
              <Field label="Model"><input className="kk-input" required value={form.model} onChange={upd("model")} /></Field>
              <Field label="Year"><input className="kk-input" type="number" value={form.year} onChange={upd("year")} /></Field>
              <Field label="KMs In"><input className="kk-input" type="number" required value={form.kms_in} onChange={upd("kms_in")} /></Field>
              <Field label="Fuel level"><input className="kk-input" value={form.fuel_level} onChange={upd("fuel_level")} /></Field>
              <div className="col-span-2">
                <Field label="Reported issues"><textarea className="kk-input min-h-[80px]" value={form.reported_issues} onChange={upd("reported_issues")} /></Field>
              </div>
              <div className="col-span-2">
                <Field label="Damage notes"><textarea className="kk-input min-h-[60px]" value={form.damage_notes} onChange={upd("damage_notes")} /></Field>
              </div>
              <div className="col-span-2">
                <FileUploader
                  category="intake"
                  ids={form.image_ids}
                  onChange={(ids) => setForm({ ...form, image_ids: ids })}
                  label="Walk-around photos (full quality, compressed on delivery)"
                />
              </div>
            </div>
            <button className="kk-btn-primary mt-6" type="submit" data-testid="save-intake">Create Intake</button>
          </form>
        </div>
      )}
    </div>
  );
}
